<template>
    <mdb-container fluid>
        <mdb-row>
            <mdb-col offset="2" col="2" class="d-flex flex-column align-items-center lime accent-1 py-3 rounded">
                <div>{{count_pending}}</div>
                <div>Pending</div>
            </mdb-col>
            <mdb-col offset="1" col="2" class="d-flex flex-column align-items-center green accent-1 py-3 rounded">
                <div>{{count_approved}}</div>
                <div>Approved</div>
            </mdb-col>
            <mdb-col offset="1" col="2" class="d-flex flex-column align-items-center red accent-1 py-3 rounded">    
                <div>{{count_rejected}}</div>
                <div>Rejected</div>
            </mdb-col>
        </mdb-row>
        <mdb-row>
            <mdb-col md="3">
                <div class="form-group">
                    <mdb-date-picker :autoHide="true" v-model="date_from" label="Date From" />
                </div>
            </mdb-col>
            <mdb-col md="3">
                <div class="form-group">
                    <mdb-date-picker :autoHide="true"  v-model="date_to" label="Date To" />
                </div>
            </mdb-col>
            <mdb-col md="3" class="d-flex align-items-center">
                <select v-model="rider_select" class="browser-default custom-select">
                    <option value="">All Rider</option>
                    <option v-for="partner in partners" v-bind:key="partner.id" :value="partner.partner_profile.id">[ {{partner.partner_profile.partner_code}} ] - {{partner.partner_profile.fullname}}</option>
                </select>
            </mdb-col>
            <mdb-col md="3" class="d-flex align-items-center">
                <select v-model="status" class="browser-default custom-select">
                    <option value="">All Status</option>
                    <option value="PENDING">Pending</option>
                    <option value="APPROVED">Approved</option>
                    <option value="REJECTED">Reject</option>
                </select>
            </mdb-col>
        </mdb-row>
        <mdb-row>
            <mdb-col md="3">
                <input v-on:keyup.enter="searchData()" v-model="transaction_ref_no" type="text" placeholder="#Transaction Ref No." class="form-control">
            </mdb-col>
            <mdb-col md="3">
                <input v-on:keyup.enter="searchData()" v-model="batch_ref_no" type="text" placeholder="#Batch Ref No." class="form-control">
            </mdb-col>
            <mdb-col md="2" class="d-flex align-items-center">
                <mdb-btn @click="searchData()" v-if="!loading" outline="primary" size="sm"><mdb-icon icon="search" /> Search</mdb-btn>
                <mdb-spinner small v-if="loading" />
            </mdb-col>
        </mdb-row>
        <mdb-tbl responsive striped v-if="!loading">
            <mdb-tbl-head>
            <tr>
                <th width="5%">#</th>
                <th><div class="link-text">DateTime</div></th>
                <th><div class="link-text">Code Name</div></th>
                <th><div class="link-text">Transaction Ref No.</div></th>
                <th><div class="link-text">Amount</div></th>
                <th><div class="link-text">Status</div></th>
                <th><div class="link-text">Action</div></th>  
            </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
            <tr v-for="(record, index) in records" :key="record.id">
                <td>{{index+1}}</td>
                <td>{{momentFormat16(record.created_at)}}</td>
                <td>[ {{record.partner_profile.partner_code}} ] - {{record.partner_profile.fullname}}</td>
                <td>{{record.ref_number}}</td>
                <td>{{record.amount}}</td>
                <td>
                    <div class="text-success font-weight-bold" v-if="record.status=='APPROVED'">{{record.status}}</div>
                    <div class="text-warning font-weight-bold" v-if="record.status=='PENDING'">{{record.status}}</div>
                    <div class="text-danger font-weight-bold" v-if="record.status=='REJECTED'">{{record.status}}</div>
                </td>
                <td>
                    <div v-if="record.ref_id==null" class="custom-control custom-checkbox">
                        <input :checked="checkSelected(record)" type="checkbox" @click="toggleChecked(record)" class="custom-control-input" :id="'checkbox-'+record.id">
                        <label class="custom-control-label" :for="'checkbox-'+record.id"></label>
                    </div>
                    <div class="link-text" @click="hyperlinkBatch(record.ref_number2)">{{record.ref_number2}}</div>
                    <div class="text-success">{{record.remark2}}</div>
                </td>
            </tr>
            </mdb-tbl-body>
        </mdb-tbl>
        <mdb-row class="pb-3">
            <mdb-col col="12">
                <mdb-spinner small v-if="action_loading" />
                <mdb-btn size="sm" @click="continueWithdrawal" v-if="selected_records.length!=0 && !action_loading" color="primary">Generate Withdrawal</mdb-btn>
            </mdb-col>
        </mdb-row>
        <BatchNameModal :visible="batch_name_modal" :selected_records="selected_records" :close="closeModal" :submit="submitWithdrawal" />
    </mdb-container>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbBtn, mdbCol, mdbRow, mdbSpinner, mdbDatePicker, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon} from 'mdbvue';
import {ajax} from '../js/ajax';
import {momentFormat16} from '../js/helper';
import BatchNameModal from '../components/BatchNameModal.vue'

export default {
    name: 'partner_withdrawal_list',
    components: {
        mdbContainer, mdbBtn, mdbCol, mdbRow, mdbSpinner, mdbIcon, mdbDatePicker, mdbTbl, mdbTblHead, mdbTblBody, BatchNameModal
    },
    props: ['navigate'],
    data: ()=>({
        date_from: "",
        date_to: "",
        rider_select: "",
        partners: [],
        loading:false,
        count_pending: 0,
        count_rejected: 0,
        count_approved: 0,
        records: [],
        selected_records: [],
        batch_name_modal: false,
        action_loading: false,
        batch_ref_no: "",
        transaction_ref_no: "",
        status: ""
    }),
    methods: {
        closeModal(){
            this.batch_name_modal=false;
        },
        getRiderData(){
            ajax({
                url: "admin/get_partner_list",
                success: result=>{
                    this.partners=result.data;
                    this.partners.sort((a, b)=>{
                        if(a.partner_profile.partner_code < b.partner_profile.partner_code) { return -1; }
                        if(a.partner_profile.partner_code > b.partner_profile.partner_code) { return 1; }
                        return 0;
                    })
                },
                fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
            })
        },
        getData(){
            if(this.loading){
                return false;
            }
            this.loading=true;
            this.selected_records=[];
            ajax({
                url: "admin/get_partner_withdrawals",
                data: {
                    date_from: this.date_from,
                    date_to: this.date_to,
                    partner_profile_id: this.rider_select,
                    // type: this.type,
                    batch_ref_no: this.batch_ref_no,
                    transaction_ref_no: this.transaction_ref_no,
                    status: this.status
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    this.records=result.data.withdrawals;
                    this.count_pending=result.data.count_pending;
                    this.count_rejected=result.data.count_rejected;
                    this.count_approved=result.data.count_approved;
                },
            }, this)
        },
        momentFormat16(date){
            return momentFormat16(date);
        },
        toggleChecked(record){
            let selected_records=[...this.selected_records];
            let found_index = selected_records.findIndex(element=>{
                return element.id==record.id;
            })
            if(found_index>=0){
                //delete
                selected_records.splice(found_index, 1);
            }else{
                //add
                selected_records.push(record);
            }
            this.selected_records=selected_records;
        },
        checkSelected(record){
            let result= this.selected_records.findIndex(element=>{
                return element.id==record.id;
            })
            if(result>=0){
                return true;
            }
            return false;
        },
        submitWithdrawal(text){
            if(this.action_loading){
                return false;
            }
            this.action_loading=true;
            ajax({
                url: "admin/submit_withdrawal_batch",
                data: {
                    transactions: this.selected_records,
                    wallet_withdrawal_name: text
                },
                complete: ()=>this.action_loading=false,
                success: ()=>{
                    this.getData();
                },
            }, this)
        },
        continueWithdrawal(){
            this.batch_name_modal=true;
        },
        searchData(){
            this.records=[];
            this.getData();
        },
        hyperlinkBatch(ref_no){
            this.navigate(ref_no)
        },
        accept(obj){
            this.batch_ref_no=obj;
            this.searchData();
        },
    },
    mounted: function(){
        let date = new Date();
        let month = date.getMonth()+1;
        this.date_from=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        this.date_to=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        this.getData();
        this.getRiderData();
    }
}
</script>

<style scoped>
.link-text:hover{
    color: #4285F4;
    font-weight: bold;
}
.link-text{
    font-weight: bold;
}
</style>